export function initMenu() {
  const body = document.body;
  const expandableLinks = document.querySelectorAll(".menu__link--dropdown");
  const menuToggle = document.querySelectorAll("[data-menu-toggle]");

  if (menuToggle) {
    menuToggle.forEach(item => {
      item.addEventListener("click", function() {
        body.classList.toggle("menu-is-open");
      });
    });
  }

  expandableLinks.forEach(link => {
    link.addEventListener("click", function(e) {
      e.preventDefault();
      const submenu = this.nextElementSibling;

      // Close all other submenus first
      expandableLinks.forEach(otherLink => {
        if (otherLink !== this) {
          otherLink.classList.remove("active");
          otherLink.nextElementSibling.classList.remove("active");
        }
      });

      // Toggle the clicked submenu
      this.classList.toggle("active");
      submenu.classList.toggle("active");
    });
  });
}
